import * as zod from 'zod';

export const RobotOperationMode = zod
  .enum([
    'live',
    'simulated',
    'assembly',
    'assembly_simulated',
    'calibration',
    'echo',
    'gpu',
    'multi_sim',
    'unknown',
  ])
  .default('live');

export type RobotOperationMode = zod.infer<typeof RobotOperationMode>;

// 'k8s' = gke-cloud-bots sim pod. Missing from this enum it fails the
// whole RobotIdentityData parse, and the remote-control client's
// fallback identity defaults robotOperationMode to 'live' — the UI then
// treats a cloud sim as a physical robot (live-robot firmware checks,
// warnings on the software-update screen, wrong sim affordances).
export const HostType = zod.enum(['vm', 'control-box', 'k8s']);

export type HostType = zod.infer<typeof HostType>;

// Mirrors ModelType in @sb/robot ('RO1' | 'Thor' | 'Spark') — inlined
// because @sb/robot imports this lib, so importing it back would cycle.
// 'RO1' is the DB enum value for both RO1 and RO2 hardware.
export const RobotIdentityModel = zod.enum(['RO1', 'Thor', 'Spark']);

export type RobotIdentityModel = zod.infer<typeof RobotIdentityModel>;

export const RobotIdentityData = zod.object({
  robotId: zod.string(),
  alias: zod.string(),
  cloudflareTunnelId: zod.string().optional(),
  applicationUrl: zod.string().nullable().default(null),
  robotOperationMode: RobotOperationMode,
  hostType: HostType.optional(),
  hostname: zod.string().optional(),
  // Robot model this bot is declared to be at provision time (cloud sims:
  // createVM writes it). Consumed as a first-boot seed/fallback only — once
  // a robots row carries a model, the DB stays the runtime source of truth,
  // so a control-panel model switch is never reverted by this field.
  robotModel: RobotIdentityModel.optional(),
});

export type RobotIdentityData = zod.infer<typeof RobotIdentityData>;
